import { PARAMETER_SRS_CODE } from '@disy/lib.backend/api-constants';

import { ajax } from 'cadenza/api-client/api';
import type { Timeline3dConfigDto } from 'cadenza/api-client/dto/timeline3d-config-dto';
import type { TimelineDto, TimelinesDto } from 'cadenza/api-client/timeline-dto';
import { createWorkbookUrl } from 'cadenza/api-client/workbook-api';
import type { WorkbookNameAndHash } from 'cadenza/repository/model/workbook-name-and-hash';
import type { ViewId } from 'cadenza/workbook/api/view-id';

/// see net/disy/cadenza/workbook/web/map/timeline/dto/TimelineDisplayMode.java
type TimelineDisplayMode = 'TIMELINE_2D' | 'TIMELINE_3D';

export function getTimelinesFor3d(
  workbookNameAndHash: WorkbookNameAndHash,
  viewId: ViewId,
  srs: string,
  allowLargeData: boolean,
  signal: AbortSignal,
): Promise<TimelinesDto> {
  return getAllTimelines(workbookNameAndHash, viewId, srs, allowLargeData, signal, 'TIMELINE_3D');
}

function getAllTimelines(
  workbookNameAndHash: WorkbookNameAndHash,
  viewId: ViewId,
  srs: string,
  allowLargeData: boolean,
  signal: AbortSignal,
  displayMode: TimelineDisplayMode,
): Promise<TimelinesDto> {
  const data: Record<string, unknown> = {
    [PARAMETER_SRS_CODE]: srs,
    displayMode,
  };
  if (allowLargeData) {
    data.allowLargeData = true;
  }
  return ajax(`${createWorkbookUrl(workbookNameAndHash, { viewId })}/timelines`, {
    signal,
    data,
  });
}

export function getTimelinesFor2d(
  workbookNameAndHash: WorkbookNameAndHash,
  viewId: ViewId,
  srs: string,
  allowLargeData: boolean,
  signal: AbortSignal,
): Promise<TimelinesDto> {
  return getAllTimelines(workbookNameAndHash, viewId, srs, allowLargeData, signal, 'TIMELINE_2D').then(
    (timelinesResult) => {
      return {
        ...timelinesResult,
        timelines: filterOutTimelinesOfInvisibleLayers(timelinesResult.timelines),
      };
    },
  );
}

export function getTimeline3dConfig(workbookNameAndHash: WorkbookNameAndHash, viewId: ViewId) {
  return ajax<Timeline3dConfigDto>(`${createWorkbookUrl(workbookNameAndHash, { viewId })}/timeline-3d-config`);
}

function filterOutTimelinesOfInvisibleLayers(timelines: TimelineDto[]) {
  return timelines.filter((timeline) => (timeline.points || []).length > 0);
}
